// Feature "JSON enum" as a const-object + type
export const SupportedFeature = {
  base: "base",
  shadow3D: "3d_shadow",
  distort: "distort",
  stretch: "stretch",
  roundedText: "rounded_text",
  textSpacing: "text_spacing",
  gif: "gif",
  stopMotion: "stop_motion",
  videoLayer: "video_layer",
  animation: "animation",
  scenes: "scenes",
  transition: "transition",
  music: "music",
  glow: "glow",
  reflection: "reflection",
  cornerRadius: "corner_radius",
  textStyleByFont: "text_style_by_font",
  complexStyle: "complex_style",
  multiPageBg: "multi_page_bg",
  multiPageSize: "multi_page_size",
} as const;

export type SupportedFeature = typeof SupportedFeature[keyof typeof SupportedFeature];

// If you want just the list of values (e.g., to serialize as JSON):
export const SupportedFeatureOnWebValues: SupportedFeature[] = [SupportedFeature.roundedText, SupportedFeature.textSpacing, SupportedFeature.base, SupportedFeature.multiPageBg, SupportedFeature.multiPageSize, SupportedFeature.textStyleByFont, SupportedFeature.scenes];

// If you want just the list of values (e.g., to serialize as JSON):
export const SupportedFeatureValues: SupportedFeature[] = Object.values(SupportedFeature);
